import React, { useState } from "react"
import Dialog from "../../../../../../../common/element/Dialog/Dialog"
import Table from "../../../../../../../common/element/Table"
import moment from "moment";
const VisitorList = (props) => {
    const { Tr, Th, Td, THead, TBody } = Table;

    return (
        <React.Fragment>
            <div className="overflow-x-auto">
                <div className="w-full inline-block align-middle">
                    <div className="overflow-hidden border rounded-lg border-gray-200">
                        <Table className="min-w-full divide-y divide-gray-200">
                            <THead className="bg-gray-100">
                                <Tr>
                                    <Th
                                        scope="col"
                                        className="bg-gray-100 px-4 py-3 font-medium text-left text-gray-600 w-1/3"
                                    >
                                        <span className='flex items-center gap-1' onClick={() => props?.handleSort("audit_log_text")}>Action
                                            <svg
                                                className={`transform ${props?.filtersort === "audit_log_text" && props?.filterorder === "asc"
                                                    ? "rotate-180"
                                                    : ""
                                                    }`}
                                                width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8" stroke="#475467" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg></span>
                                    </Th>
                                    <Th
                                        scope="col"
                                        className="bg-gray-100 px-4 py-3 font-medium text-left text-gray-600"
                                    >
                                        <span className="inline-flex items-center">
                                            User

                                        </span>
                                    </Th>

                                    <Th
                                        scope="col"
                                        className="bg-gray-100 px-4 py-3 font-medium text-left text-gray-600 w-1/5"
                                    >
                                        <span className='flex items-center gap-1' onClick={() => props?.handleSort("created_date")}>Timestamp
                                            <svg
                                                className={`transform ${props?.filtersort === "created_date" && props?.filterorder === "asc"
                                                    ? "rotate-180"
                                                    : ""
                                                    }`}
                                                width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8" stroke="#475467" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg></span>
                                    </Th>
                                </Tr>
                            </THead>
                            <TBody className="divide-y divide-gray-200">
                                {props?.auditData &&
                                    props?.auditData.map((item) => (
                                        <Tr key={item?.user_ip}>
                                            <Td dangerouslySetInnerHTML={{ __html: item?.audit_log_text || "-" }} />
                                            <Td>{item?.user ? item?.user : "-"}</Td>
                                            <Td>{item?.createdDate ? item?.createdDate : "-"}</Td>
                                        </Tr>
                                    ))}
                            </TBody>
                        </Table>
                    </div>
                </div>
            </div>

        </React.Fragment>
    )
}
export default VisitorList